import { Directive, TemplateRef } from '@angular/core';
import { CellDef } from '../table.interfaces';

@Directive({ selector: '[itrCellDef]' })
export class ItrCellDefDirective implements CellDef {
  constructor(public template: TemplateRef<any>) {}
}
